import { FaFacebook } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import contacts_data from "./contacts_data";
import { Icon } from "@iconify/react";

export default function Contacts() {

    const { t } = useTranslation();

    return <>
        <div id="contacts">
            <label className="pageTitle" >{ t("contacts") }</label>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "center", marginTop: 20, gap: 20, flexWrap: "wrap"}}>
                <a style={{display: "flex", flexDirection: "column", alignItems: "center", color: "rgb(122, 28, 62)"}}
                   href={`tel:${contacts_data.phone}`}
                >
                    {/* <FaPhone size={80}/>  */}
                    <Icon icon="ri:phone-fill" width="80" height="80"/>
                    { _normalizePhoneNumber() }
                </a>
                <a style={{display: "flex", flexDirection: "column", alignItems: "center", color: "rgb(122, 28, 62)"}} 
                     href={`mailto:${contacts_data.email}`}
                >
                    {/* <MdEmail size={80}/> */}
                     <Icon icon="ri:mail-fill" width="80" height="80"/>
                    { contacts_data.email }
                </a>
                {/* <div>
                    <a href={contacts_data.facebook}>
                        <FaFacebook/> Facebook
                    </a>
                </div> */}
            </div>
        </div>
    </>
}

function _normalizePhoneNumber() {
    return contacts_data.phone.replace(/\D(\d{3})(\d{3})(\d{3})(\d{3})/, "(+$1) $2 $3 $4");
}

